import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7fbe933d")

_pushScopeId("data-v-7fbe933d")
const _hoisted_1 = { class: "flex-center" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("发布")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("取消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "提示",
    modelValue: _ctx.publishDialogVisible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.publishDialogVisible = $event)),
    width: "40%"
  }, {
    default: _withId(() => [
      _createVNode(_component_el_form, {
        ref: "formDom",
        model: _ctx.formData,
        "label-width": "80px"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_form_item, {
            required: "",
            prop: "comment",
            rules: [{
                      required: true, message: '变更说明不能为空'
                    }],
            label: "变更说明"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                type: "textarea",
                rows: "2",
                modelValue: _ctx.formData.comment,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.comment = $event))
              }, null, 8, ["modelValue"]),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.commonComments, (comment) => {
                return (_openBlock(), _createBlock(_component_el_tag, {
                  key: comment,
                  onClick: ($event: any) => (_ctx.formData.comment = comment),
                  "disable-transitions": false
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(comment), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode(_component_el_button, {
                  type: "success",
                  onClick: _ctx.publish
                }, {
                  default: _withId(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, { onClick: _ctx.cancel }, {
                  default: _withId(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
})